import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Text } from '@BICE_Vida/components';
import Image from 'next/image';

import styles from './PromoHeaderFlow.module.scss';
import PromoModal from './PromoModal';
import { PROMO_CYBER } from '@/utils/assets';
import { quoteCyberDayText } from '@/utils/generalTexts';
import { IntervalCyber } from '@/utils/format';
import { breakPointSm } from '@/utils/constants';

type InfoType = {
  cyberDay: IntervalCyber | null;
};

function PromoHeaderFlow({ cyberDay }: InfoType) {
  const [isOpen, setIsOpen] = useState(false);
  const [smallSize, setScreenSize] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const onResize = useCallback(() => {
    setScreenSize(window.innerWidth <= breakPointSm);
  }, [smallSize, setScreenSize]);

  useEffect(() => {
    window.addEventListener('resize', onResize);
    onResize();

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const cyberdayText = useMemo(() => {
    switch (cyberDay) {
      case IntervalCyber.Extension:
        return quoteCyberDayText[IntervalCyber.Extension];
      case IntervalCyber.CyberDayLastDay:
        return quoteCyberDayText[IntervalCyber.CyberDayLastDay];
      default:
        return quoteCyberDayText[IntervalCyber.CyberDay];
    }
  }, [cyberDay]);

  const label = useMemo(() => {
    switch (cyberDay) {
      case IntervalCyber.CyberDayLastDay:
        return <div className={styles.last_day_label}>¡ÚLTIMO DÍA!</div>;
      default:
        return <div className={styles.label}>{cyberdayText.promoTitle}</div>;
    }
  }, [cyberDay, cyberdayText]);

  return (
    <div className={styles.cyber_header}>
      <PromoModal isOpen={isOpen} setIsOpen={setIsOpen} cyberDay={cyberDay} fromWizard />
      <div className={styles.wrapper}>
        <div className={styles.label_wrapper}>
          <div>
            <Image
              src={PROMO_CYBER.promo_banner}
              alt=""
              width={91}
              height={40}
              quality={100}
            />
          </div>
          {label}
        </div>
        <div>
          <Text className={styles.text}>
            {cyberdayText.quoteFlow(smallSize)}
            <label onClick={handleClick} onKeyDown={() => {}} aria-hidden="true">
              Ver detalles
            </label>
          </Text>
        </div>
      </div>
    </div>
  );
}

export default PromoHeaderFlow;
